:host {
  display: block;
}
.btn {
  font-size: 20px;
  font-weight: 700;
  padding: 9px;
  line-height: 1.33333;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: block;
}

.btn.primary {
  color: #fff;
  background-color: var(--color-cwru-blue);
}

.btn.secondary {
  color: var(--color-cwru-blue);
  background-color: #eee;
}

.btn.primary:hover {
  background-color: var(--color-link-blue);
}

.btn.secondary:hover {
  color: #fff;
  background-color: var(--color-link-blue);
}

.btn.inline {
  display: inline-block;
}

.btn.inline-s1 {
  display: inline-block;
  padding-left: var(--s1);
  padding-right: var(--s1);
}

.btn.displaynone {
  display: none;
}
